import { smartRound } from '../math'
import { MINUTES_PER_HOUR } from './constants'

export const minutesToHours = (
  minutes: number,
  decimalPlaces: number = 2,
): number => {
  return smartRound(minutes / MINUTES_PER_HOUR, decimalPlaces)
}
